import React from 'react';
import { ArrowRight, Clock, Mail, MapPin, Phone } from 'lucide-react';
import { company, serviceAreas } from '../data/site';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Location() {
  return <section className="w-full bg-navy py-24 lg:py-32" data-id="element-270" data-mp="lu6e5troxkk3">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-271" data-mp="qsq4059enghq">
        <Reveal data-id="element-272" data-mp="d1cmewv24spc">
          <SectionHeading label="Location" tone="dark" title="Ready to build?" description="We are based in Murfreesboro and work across Nashville and Middle Tennessee. Stop by, call, or send us the details of your project." data-id="element-273" data-mp="d0tg6derrsr5" />

          <ul className="mt-12 space-y-8 border-t border-white/10 pt-10" data-id="element-274" data-mp="83taw4pquu13">
            <li className="flex gap-5" data-id="element-275" data-mp="3q8ecc7qpxpjk">
              <MapPin className="mt-1 h-5 w-5 shrink-0 text-brand-500" strokeWidth={1.6} aria-hidden="true" data-id="element-276" data-mp="3q9fzvbox84i6" />
              <div data-id="element-277" data-mp="3uccb2hc4syc3">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-278" data-mp="z9ihen0n6iyf">Head Office</p>
                <p className="mt-2 font-heading text-lg font-bold text-white" data-id="element-279" data-mp="uaxc496j9934">{company.addressLine1}</p>
                <p className="text-white/60" data-id="element-280" data-mp="1987wy952frbi">{company.addressLine2}</p>
              </div>
            </li>
            <li className="flex gap-5" data-id="element-281" data-mp="148buwffxi9yl">
              <Phone className="mt-1 h-5 w-5 shrink-0 text-brand-500" strokeWidth={1.6} aria-hidden="true" data-id="element-282" data-mp="149d2ub1negc3" />
              <div data-id="element-283" data-mp="ggwp2coy1ail">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-284" data-mp="bjxr1j25sjf4">Call or Text</p>
                <a href={company.phoneHref} className="mt-2 block font-heading text-lg font-bold text-white hover:text-brand-400" data-id="element-285" data-mp="q9c534gojp0u">
                  {company.phone}
                </a>
              </div>
            </li>
            <li className="flex gap-5" data-id="element-286" data-mp="3twvp1kfe526n">
              <Mail className="mt-1 h-5 w-5 shrink-0 text-brand-500" strokeWidth={1.6} aria-hidden="true" data-id="element-287" data-mp="3tvswz96c0tp5" />
              <div data-id="element-288" data-mp="3owzt88gukh26">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-289" data-mp="ihtumeypkto0">Email</p>
                <a href={`mailto:${company.email}`} className="mt-2 block break-all font-heading text-lg font-bold text-white hover:text-brand-400" data-id="element-290" data-mp="minjbajz6chy">
                  {company.email}
                </a>
              </div>
            </li>
            <li className="flex gap-5" data-id="element-291" data-mp="3vodj8esuom3g">
              <Clock className="mt-1 h-5 w-5 shrink-0 text-brand-500" strokeWidth={1.6} aria-hidden="true" data-id="element-292" data-mp="3vpf3n9vrakxu" />
              <div data-id="element-293" data-mp="3ktcn36bkd2q">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-294" data-mp="3m4jxcyz42yl">Hours</p>
                <p className="mt-2 font-heading text-lg font-bold text-white" data-id="element-295" data-mp="8lqt9bbokz24">{company.hours}</p>
              </div>
            </li>
          </ul>

          <a href={company.mapsLink} target="_blank" rel="noreferrer" className="group mt-12 inline-flex items-center gap-3 bg-brand-500 px-8 py-5 text-[13px] font-bold uppercase tracking-[0.16em] text-white transition hover:bg-brand-600" data-id="element-296" data-mp="1jxi07pxnlmn9">
            Get Directions
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-297" data-mp="34hdlbt7slxwu" />
          </a>
        </Reveal>

        <Reveal delay={0.12} data-id="element-298" data-mp="2urkcgzz1bwwa">
          <div className="border border-white/10 bg-navy-800 p-3" data-id="element-299" data-mp="2uq97iwtusj3l">
            <div className="relative h-[420px] w-full overflow-hidden lg:h-[560px]" data-id="element-300" data-mp="2qpgx4098w85q">
              <iframe title={`Map showing ${company.name} in Murfreesboro, Tennessee`} src={company.mapsEmbed} className="h-full w-full border-0 grayscale-[0.35] contrast-[1.05]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-301" data-mp="2lpkua4caamrr" />
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 px-3 py-5" data-id="element-302" data-mp="eyv4h0309hvr">
              <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-400" data-id="element-303" data-mp="a1uuwf6y5wzw">
                Service Area
              </span>
              <span className="text-sm text-white/50" data-id="element-304" data-mp="n02glu2ye1tr">{serviceAreas.join(' · ')}</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}